// src/components/products/ProductForm/TransferDetailsSections/TransferNotesSection.jsx

import React from "react";
import { Grid } from "@mui/material";
import FormInput from "../../../inputs/FormInput";

const TransferNotesSection = ({
    formData,
    errors,
    activeLang,
    handleMultiLangChange,
}) => {
    const showArabic = activeLang === "ar";
    const showEnglish = activeLang === "en";

    return (
        <Grid container spacing={3}>
            {/* Notes - Arabic */}
            {showArabic && (
                <Grid item xs={12}>
                    <FormInput
                        label="ملاحظات (عربي)"
                        type="editor"
                        textareaRows={200}
                        name="notes_ar"
                        value={formData.notes?.ar || ''}
                        onChange={(e) => handleMultiLangChange('notes', 'ar', e.target.value)}
                        rows={3}
                        error={!!errors.notes_ar}
                        helperText={errors.notes_ar}
                    />
                </Grid>
            )}

            {/* Notes - English */}
            {showEnglish && (
                <Grid item xs={12}>
                    <FormInput
                        label="Notes (English)"
                        type="editor"
                        textareaRows={200}
                        name="notes_en"
                        value={formData.notes?.en || ''}
                        onChange={(e) => handleMultiLangChange('notes', 'en', e.target.value)}
                        rows={3}
                        error={!!errors.notes_en}
                        helperText={errors.notes_en}
                    />
                </Grid>
            )}
        </Grid>
    );
};

export default TransferNotesSection;
